// extracted by mini-css-extract-plugin
module.exports = {"food_box":"food_box-3JjxF1pE"};